(() => {
  const header = document.querySelector("[data-header]");
  const hamburger = document.getElementById("hamburger");
  const drawer = document.getElementById("navMenu");

  const onScroll = () => {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 12);
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  const closeMenu = () => {
    document.body.classList.remove("menu-open");
    if (hamburger) hamburger.setAttribute("aria-expanded", "false");
    if (drawer) drawer.hidden = true;
  };

  const openMenu = () => {
    document.body.classList.add("menu-open");
    if (hamburger) hamburger.setAttribute("aria-expanded", "true");
    if (drawer) drawer.hidden = false;
  };

  if (hamburger && drawer) {
    hamburger.addEventListener("click", () => {
      if (document.body.classList.contains("menu-open")) closeMenu();
      else openMenu();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeMenu();
    });
    document.addEventListener("click", (e) => {
      if (!document.body.classList.contains("menu-open")) return;
      if (drawer.contains(e.target) || hamburger.contains(e.target)) return;
      closeMenu();
    });
    window.addEventListener("resize", () => {
      if (window.innerWidth > 860) closeMenu();
    });
  }

  const section = document.querySelector("[data-product-section]");
  if (!section) return;

  const jsonEl = section.querySelector("[data-product-json]");
  const moneyEl = section.querySelector("[data-money-format]");
  const idInput = section.querySelector("[data-variant-id]");
  const stock = section.querySelector("[data-stock]");
  const addBtn = section.querySelector("[data-add]");
  const buyNow = section.querySelector("[data-buy-now]");
  const sticky = section.querySelector("[data-sticky-atc]");
  const stickyAdd = section.querySelector("[data-sticky-add]");
  const form = section.querySelector("[data-product-form]");
  const mainImg = section.querySelector("[data-gallery-main]");
  const thumbs = section.querySelectorAll("[data-thumb]");
  const priceWrap = section.querySelector("[data-price-wrap]");

  let variants = [];
  try {
    variants = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }

  const moneyFormat = moneyEl ? JSON.parse(moneyEl.textContent) : "${{amount}}";
  const installments = 12;

  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2).replace(".", ",");
    const withSep = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return moneyFormat.replace(/\{\{\s*amount.*?\}\}/, withSep);
  };

  const selected = () => {
    const values = [];
    section.querySelectorAll("[data-option-position]").forEach((input) => {
      if (input.checked) values[Number(input.dataset.optionPosition) - 1] = input.value;
    });
    return variants.find((v) => v.options.every((opt, i) => opt === values[i])) || variants[0];
  };

  const applyVariant = (variant) => {
    if (!variant || !idInput) return;
    idInput.value = variant.id;
    if (stock) stock.textContent = variant.available ? "Disponible" : "Sin stock";
    if (addBtn) addBtn.disabled = !variant.available;
    if (buyNow) buyNow.disabled = !variant.available;
    if (stickyAdd) stickyAdd.disabled = !variant.available;
    if (priceWrap) {
      const cuota = Math.floor(variant.price / installments);
      priceWrap.innerHTML = `<div class="price"><span class="price-current">${formatMoney(variant.price)}</span><span class="price-cuotas">${installments} cuotas de ${formatMoney(cuota)}</span></div>`;
    }
    if (variant.featured_image && mainImg) {
      mainImg.src = variant.featured_image.src.includes("?")
        ? variant.featured_image.src
        : `${variant.featured_image.src}&width=1600`;
    }
  };

  section.querySelectorAll("[data-option-position]").forEach((input) => {
    input.addEventListener("change", () => applyVariant(selected()));
  });

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      thumbs.forEach((t) => t.classList.remove("is-active"));
      thumb.classList.add("is-active");
      if (mainImg) mainImg.src = thumb.dataset.src;
    });
  });

  const addToCart = async (goCheckout) => {
    if (!form) return;
    const data = new FormData(form);
    await fetch("/cart/add.js", { method: "POST", body: data, headers: { Accept: "application/json" } });
    if (goCheckout) window.location.href = "/checkout";
    else window.location.href = "/cart";
  };

  if (buyNow) {
    buyNow.addEventListener("click", (e) => {
      e.preventDefault();
      addToCart(true);
    });
  }

  if (stickyAdd) {
    stickyAdd.addEventListener("click", () => addToCart(false));
  }

  if (sticky && addBtn) {
    const io = new IntersectionObserver((entries) => {
      const visible = entries[0].isIntersecting;
      sticky.hidden = visible;
    });
    io.observe(addBtn);
  }
})();
